import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface NotificationActiverCerclePictoProps extends pictoProps {
}

export interface NotificationActiverCerclePictoState extends pictoState {
}

export class NotificationActiverCerclePicto extends Picto<NotificationActiverCerclePictoProps,NotificationActiverCerclePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.notificationActiverCerclePicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(NotificationActiverCerclePicto);
